import initSliderPost from './slider';

export default ({ slider }) => {
  initSliderPost(slider);
};
